import React, { useState  } from 'react';

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
import Login from './Component/Logincomponent/Login'
import IdleTimerContainer from './IdleTimerContainer'
import Dashboard from './Component/Dashboardcomponent/Dashboard'
import Header from './Component/header/header'
import Side from './Component/sidebar/side'
import Userprof from './Component/UserComponent/UserProfile/Userprofile'
import Bakoff from './Component/UserComponent/BackofficeComponent/Backoffice'
import Forgot from './Component/Logincomponent/ForgotPassword'
import NotFound from './NotFound' 
 

export default function App(){
  
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const login = () => {
    setIsLoggedIn(true);
  }
  const logout = () => {
    setIsLoggedIn(false);
  } 
   
  return (
   
    // <BrowserRouter basename={process.env.PUBLIC_URL}>
       <Router> 
        <Switch>
          <Route path="/ForgotPassword">
            <Forgot />
          </Route>
            
            <Route path="/"  exact>
            <Login />
            </Route>

            
          
            <Route path="/Dashboard" >
            <IdleTimerContainer></IdleTimerContainer>
              <Header> 
              </Header>
              <Side />
            <Dashboard />
            </Route>
            <Route component={NotFound} />


        </Switch>
       
    </Router>
 
  );
 
}



